import { render, staticRenderFns } from "./SmsReservationDetail.vue?vue&type=template&id=e6c1b45a&"
import script from "./SmsReservationDetail.vue?vue&type=script&lang=ts&"
export * from "./SmsReservationDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports